import { useEffect, useState } from 'react';

/**
 * Nåtiden, oppdatert på hvert minuttskifte. Delt med klokka på PIN-skjermen
 * (#160), så begge bytter minutt samtidig uten å tikke hvert sekund.
 */
export function useMinuteClock(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    const align = 60_000 - (Date.now() % 60_000);
    const timeout = setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => setNow(new Date()), 60_000);
    }, align);
    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, []);

  return now;
}
